export type WishlistDispatch = (action: string) => Promise<unknown>;

export function retryWishlistRecovery(
  dispatch: WishlistDispatch,
  authenticated: boolean
) {
  return dispatch(
    authenticated ? "store/wishlist/afterAuthentication" : "store/wishlist/load"
  );
}
